/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ source: NonNullable<unknown> }} Error_Zns_Value_MissingInputs */

const vi_error_zns_value_missing = /** @type {(inputs: Error_Zns_Value_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thiếu giá trị cho nguồn dữ liệu ${i?.source}.`)
};

/**

* @param {Error_Zns_Value_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_value_missing = /** @type {((inputs: Error_Zns_Value_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Value_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_value_missing(inputs)
});